import React from 'react'
import classNames from 'classnames'

export const ApplicationListItemAdditionalMessage = (props) => {
  return(
    <div styleName="app-card__message">
      <p styleName="app-card__message-copy" dangerouslySetInnerHTML={{__html: props.t(`customer_applications.additional_message.${props.status}`)}}></p>
    </div>
  )
}

export const ApplicationListItemContinueCta = (props) => {
  const {
    id,
    navigateToOpenApplication
  } = props
  return(
    <div styleName={'app-card__cta'}>
      <a href={navigateToOpenApplication(id)} styleName="button button--primary">
        <span>Continue</span>
        <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
      </a>
    </div>
  )
}

export const ApplicationListItemViewCta = (props) => {
  const {
    id,
    navigateToOpenApplication
  } = props
  return(
    <div styleName={"app-card__cta"}>
      <a href={navigateToOpenApplication(id)} styleName="app-card__cta-hyperlink">
        <span>View Application</span>
      </a>
    </div>
  )
}

export const ApplicationListHeading = (props) => {
  const {
    t,
    in_review
  } = props
  return(
    <h3 styleName="app-card__header-wide heading heading--small">{t(`customer_applications.customer_application_heading.${in_review}`)}</h3>
  )
}

export const ApplicationListItem = (props) => {
  const {
    components: {
      Default,
      Cta = () => null,
      Heading = () => null
    },
    in_review,
    t,
    getApplicationItemAdditionalMessageLayout,
    RenderComponent
  } = props
  //Complete outstanding tasks
  const status = in_review ? 'review' : 'incomplete'
  return(
    <div styleName={`app-card app-card--${status}`}>
      <Heading status={status} />
      <div styleName="app-card__content">
        <div styleName={'app-card__group'}>
          {Default.map((Elem, index) => {
            return <Elem key={index} />
          })}
        </div>
        <Cta />
      </div>
      <RenderComponent layout={getApplicationItemAdditionalMessageLayout(status)} status={status} />
    </div>
  )
}
